import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { MainLayout, DeepLinkLayout } from "@/apps/liff/layouts";
import { LiffProvider } from "@/apps/@components/liff-context";
import { api } from "@utils/index";
import liff from "@line/liff";
import { BindingProvider } from "@/apps/@components/binding-context";
import { UserEventApi } from "@utils/api/analytics/user-event.api";

const parsedQueryString = {};
const isLineLogin = process.env.REACT_APP_LIFF_LOGIN;

const LoginGuard = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	const initializeLiff = async () => {
		try {
			await liff.init({ liffId: process.env.REACT_APP_LIFF_ID });

			if (!liff.isLoggedIn()) {
				liff.login({ redirectUri: window.location.href });
				return;
			}

			// 檢查 token 是否有效
			await checkToken();
			await checkLogToken();

			try {
				localStorage.setItem("ec_liff_display_remind", "true");
			} catch (e) {
				console.log("Failed to access localStorage", e);
			}
		} catch (error) {
			console.error("LIFF Initialization failed:", error);
		}
	};

	// 檢查 token 是否有效
	const checkToken = async () => {
		const storedToken = localStorage.getItem("api_token");

		if (storedToken) {
			const isValidToken = await getSelf();
			if (!isValidToken) {
				await refreshAccessToken();
			} else {
				setIsAuthenticated(true);
			}
		} else {
			await refreshAccessToken();
		}
	};

	// 重新獲取登入 token 和用戶資料
	const refreshAccessToken = async () => {
		await getLoginApiToken();
		await getSelf();
	};

	const checkLogToken = async () => {
		localStorage.getItem("DATA_TOKEN");
		const dataToken = localStorage.getItem("DATA_TOKEN");
		if (dataToken) {
			const ts = Math.floor(Date.now() / 1000);
			const isValidToken = await UserEventApi.logPage({ path: "liff", ts });
			if (!isValidToken) {
				await getLogLoginApiToken();
			}
		} else {
			await getLogLoginApiToken();
		}
	};

	const getLoginApiToken = async () => {
		const accessToken = liff.getAccessToken();
		const profile = await liff.getProfile();
		const friendship = await liff.getFriendship();

		if (!friendship.friendFlag) {
			console.error("Not a friend, redirecting to official account page.");
			window.location.href = process.env.REACT_APP_LINE_OA_URL;
			return;
		}
		const friendStatusChanged =
			parsedQueryString.friendship_status_changed === "true";
		const { userId: line_uid } = profile;
		const loginData = {
			line_uid,
			access_token: accessToken,
			friendship: friendship.friendFlag,
			friendship_status_changed: friendStatusChanged,
		};
		const res = await api.post("/login", loginData);

		const api_token = res.access_token;
		localStorage.setItem("api_token", api_token);
	};

	const getLogLoginApiToken = async () => {
		try {
			let accessToken = "xxxx";
			let profile = {
				userId: "",
				displayName: "",
			};
			if (isLineLogin === "true") {
				accessToken = liff.getAccessToken() ?? "";
				profile = await liff.getProfile();
			}
			const res = await UserEventApi.loginEvent({
				line_uid: profile.userId,
				line_name: profile.displayName,
				liff_id: process.env.REACT_APP_LIFF_ID ?? "",
				access_token: accessToken,
			});
			const data_api_token = res.jwt;
			localStorage.setItem("DATA_TOKEN", data_api_token);
		} catch (error) {
			console.error("Login failed", error);
		}
	};

	const getSelf = async () => {
		try {
			const res = await api.get("/me");
			setIsAuthenticated(true);
			return res;
		} catch (error) {
			console.error("Token validation failed", error);
			setIsAuthenticated(false);
			return false;
		}
	};

	useEffect(() => {
		if (isLineLogin === "true") {
			initializeLiff();
		} else {
			setIsAuthenticated(true);
		}
	}, []);

	if (!isAuthenticated) {
		return null;
	}

	return (
		isAuthenticated && (
			<BindingProvider>
				<LiffProvider>
					<DeepLinkLayout>
						<MainLayout>
							<Outlet />
						</MainLayout>
					</DeepLinkLayout>
				</LiffProvider>
			</BindingProvider>
		)
	);
};

export default LoginGuard;
